import React from "react";

const DigitalAbout = () => {
  const brandPurple = "#c026d3";
  const brandCyan = "#06b6d4";

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#1e293b",
        backgroundColor: "#ffffff",
        padding: "50px 0 70px",
        marginTop: "-50px",
      }}
    >
      <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "0 20px" }}>
        {/* ================= 1. Header / Hero Section ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "50px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          {/* Left Image Collage */}
          <div style={{ position: "relative" }}>
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=85"
              alt="Digital Agency Team"
              style={{
                width: "100%",
                height: "380px",
                borderRadius: "16px",
                objectFit: "cover",
                display: "block",
                boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                right: "-20px",
                background: "#ffffff",
                padding: "16px 24px",
                borderRadius: "12px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                border: "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "800",
                  color: brandPurple,
                  display: "block",
                  lineHeight: "1",
                }}
              >
                100%
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                Creative Excellence
              </span>
            </div>
          </div>

          {/* Right Content */}
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                letterSpacing: "1.2px",
                marginBottom: "10px",
                display: "block",
                textTransform: "uppercase",
              }}
            >
              ✦ MEET IDS — DIGITAL, INNOVATIVE, CREATIVE
            </span>

            <h2
              style={{
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#0f172a",
                margin: "0 0 18px 0",
              }}
            >
              Building Iconic Brands in the{" "}
              <span style={{ color: brandPurple }}>Digital Era</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              <strong style={{ color: brandPurple }}>
                ICONIC DIGITAL SOLUTION (IDS)
              </strong>{" "}
              is a full-service modern IT and digital agency operating at the
              intersection of technology, creative design, and growth strategy.
            </p>

            <blockquote
              style={{
                borderLeft: `4px solid ${brandPurple}`,
                margin: "0 0 24px 0",
                paddingLeft: "16px",
                fontStyle: "italic",
                color: "#334155",
                fontSize: "15px",
                lineHeight: "1.6",
                background: "#fdf4ff",
                padding: "12px 16px",
                borderRadius: "0 8px 8px 0",
              }}
            >
              "Your vision, our technology — together we build an iconic digital
              future."
            </blockquote>

            <div style={{ display: "flex", gap: "16px" }}>
              <button
                style={{
                  background: brandPurple,
                  color: "#ffffff",
                  border: "none",
                  padding: "12px 26px",
                  fontWeight: "700",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Contact Us →
              </button>

              <button
                style={{
                  background: "transparent",
                  border: `2px solid ${brandPurple}`,
                  color: brandPurple,
                  padding: "12px 26px",
                  fontWeight: "700",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Our Portfolio
              </button>
            </div>
          </div>
        </div>

        {/* ================= 2. Stats Bar ================= */}
        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e2e8f0",
            padding: "32px 24px",
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
            textAlign: "center",
          }}
        >
          {[
            { value: "250+", label: "Successful Campaigns" },
            { value: "120+", label: "Global Clients" },
            { value: "98%", label: "Client Retention" },
            { value: "24/7", label: "Creative Support" },
          ].map((stat, i) => (
            <div key={i}>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: "800",
                  color: brandCyan,
                  display: "block",
                  lineHeight: "1.1",
                  marginBottom: "4px",
                }}
              >
                {stat.value}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* ================= 3. Mission & Vision Cards ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "24px",
            marginBottom: "70px",
          }}
        >
          <div
            style={{
              background: "#fdf4ff",
              border: "1px solid #f5d0fe",
              color: "#0f172a",
              padding: "36px 30px",
              borderRadius: "16px",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                fontWeight: "800",
                color: brandPurple,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              OUR PURPOSE
            </span>
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "800",
                margin: "8px 0 12px 0",
                color: brandPurple,
              }}
            >
              Our Mission
            </h3>
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.65",
                color: "#475569",
                margin: 0,
              }}
            >
              To deliver innovative, creative, and data-driven digital solutions
              that help businesses expand their brand reach, convert audiences,
              and achieve sustainable long-term growth.
            </p>
          </div>

          <div
            style={{
              background: "#ecfeff",
              border: "1px solid #a5f3fc",
              color: "#0f172a",
              padding: "36px 30px",
              borderRadius: "16px",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                fontWeight: "800",
                color: brandCyan,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              OUR AMBITION
            </span>
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "800",
                margin: "8px 0 12px 0",
                color: brandCyan,
              }}
            >
              Our Vision
            </h3>
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.65",
                color: "#475569",
                margin: 0,
              }}
            >
              To become a globally recognized leader in digital agency services
              by setting benchmark standards in strategy, creativity, software
              development, and branding excellence.
            </p>
          </div>
        </div>

        {/* ================= 4. Core Agency Services ================= */}
        <div style={{ marginBottom: "70px" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              WHAT WE DO
            </span>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "800",
                margin: "8px 0 0 0",
                color: "#0f172a",
              }}
            >
              Comprehensive Digital{" "}
              <span style={{ color: brandCyan }}>Services</span>
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {[
              {
                title: "Digital Marketing & Growth",
                desc: "Data-driven SEO, PPC campaigns, and performance marketing designed for maximum ROI.",
              },
              {
                title: "Brand Identity & Design",
                desc: "Memorable logo design, brand guidelines, and UI/UX assets that captivate audiences.",
              },
              {
                title: "Social Media Strategy",
                desc: "Content creation, influencer outreach, and community engagement across channels.",
              },
              {
                title: "Custom Web Development",
                desc: "High-speed, responsive, and secure web applications built on modern tech frameworks.",
              },
              {
                title: "E-Commerce Solutions",
                desc: "Scalable online stores with seamless payment gateway and inventory integrations.",
              },
              {
                title: "Video Production & Motion",
                desc: "High-quality promotional videos, motion graphics, and rich multimedia storytelling.",
              },
            ].map((service, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "26px 22px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#64748b",
                    lineHeight: "1.6",
                  }}
                >
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 5. Bottom CTA Banner ================= */}
        <div
          style={{
            background: "linear-gradient(90deg, #c026d3 0%, #06b6d4 100%)",
            padding: "40px",
            borderRadius: "16px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "26px",
                fontWeight: "800",
                color: "#ffff",
              }}
            >
              Ready to Scale Your Brand?
            </h3>
            <p style={{ margin: 0, fontSize: "15px", opacity: 0.95 }}>
              Let's collaborate and transform your business with our digital
              agency solutions.
            </p>
          </div>

          <button
            style={{
              background: "#ffffff",
              color: "#0f172a",
              border: "none",
              padding: "14px 28px",
              borderRadius: "8px",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            Start Your Project →
          </button>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style*="gridTemplateColumns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="gridTemplateColumns: repeat(4, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            div[style*="gridTemplateColumns: repeat(3, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 640px) {
            div[style*="gridTemplateColumns: repeat(4, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="justifyContent: space-between"] {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default DigitalAbout;
